import { getAcctNoFromUrl } from '../../utils/appointments/accountContext';
import { compressAndConvertToBase64 } from '../../utils/imageCompressor';
// Headless UI Combobox and Heroicons imports for calendar dropdown
import { Combobox, ComboboxOption, ComboboxLabel } from '../../fieldsComponents/appointments/combobox';
import { CalendarDaysIcon } from '@heroicons/react/20/solid';
import React, { useState, useEffect, useRef } from 'react';
import { Button } from '../../fieldsComponents/appointments/button';

import BookingAppoinment from './bookingAppointment';
import AppointmentSetupPage from './appointmentSetupPage';
import { Switch, SwitchField } from '../../fieldsComponents/appointments/switch';
import { Label } from '../../fieldsComponents/appointments/fieldset';
import LoadingMask from '../../components/appointments/loadingMask'; // Import the LoadingMask component
import { useNotifications } from '../../components/appointments/notifications';
import DeleteConfirmation from '../../components/appointments/deleteConfirmation';
import { FaPencilAlt, FaUserCircle, FaRegCopy, FaCamera } from 'react-icons/fa'; // Added FaCamera
import AddCalendarDialog from '../../components/appointments/addCalendarDialog'; // Import the AddCalendarDialog component
import { useLocation } from 'react-router-dom';


import { PlusIcon, TrashIcon, CloudArrowUpIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { CogIcon } from '@heroicons/react/24/outline';
import CategoryPage from './categoryPage';
import { useOutletContext } from "react-router-dom";

function GoogleCalendarPanel({ acc }) {
  const [isEditingCalendarId, setIsEditingCalendarId] = useState(false);
  // Add calendarIdcopy state to avoid no-undef errors
  const [calendarIdcopy, setCalendarIdcopy] = useState('primary');



  // Get context values before any use
  const { setIsPanelLoading, isPanelLoading, acctId, setAcctId, acctIdLoading } = useOutletContext();



  // All code using acctId must come after this line
  // Get context values before any use or hook
  // DEBUG: Log context and localStorage account info on mount

  // Refresh categories when a new category is added from the Category tab
  useEffect(() => {
    const handleCategoryListUpdated = () => {
      fetchCategories();
    };
    window.addEventListener('categoryListUpdated', handleCategoryListUpdated);
    return () => {
      window.removeEventListener('categoryListUpdated', handleCategoryListUpdated);
    };
  }, []);
  // State for Appointment Setup/Category modal
  const [isAppointmentSetupOpen, setIsAppointmentSetupOpen] = useState(false);
  const [activeSetupTab, setActiveSetupTab] = useState('setup');

  // Listen for event to open dialog and switch to category tab
  useEffect(() => {
    const handleOpenCategoryTab = () => {
      setIsAppointmentSetupOpen(true);
      setActiveSetupTab('category');
    };
    window.addEventListener('openGoogleCalendarCategoryTab', handleOpenCategoryTab);
    return () => {
      window.removeEventListener('openGoogleCalendarCategoryTab', handleOpenCategoryTab);
    };
  }, []);


  const { showSuccess, showError, NotificationComponent } = useNotifications();
  const [isConnected, setIsConnected] = useState(false);
  const [isConnectionStatusReady, setIsConnectionStatusReady] = useState(false); // Track if connection status is determined

  // Removed local acctIdLoading, use context value instead

  const lastFetchedCalendarRef = useRef(null);
  const isFetchingCalendarRef = useRef(false);

  const [email, setEmail] = useState(null);
  const [timeZone, setTimeZone] = useState(null);
  const [googlePicture, setGooglePicture] = useState(null);
  const [newProfileImage, setNewProfileImage] = useState(null);
  const [newProfileImagePreview, setNewProfileImagePreview] = useState(null);
  const [isProfileImageLoading, setIsProfileImageLoading] = useState(true); // Initialize as true
  const fileInputRef = useRef(null);

  const [isCalendarsLoading, setIsCalendarsLoading] = useState(true); // Add this line
  const [activeTab, setActiveTab] = useState('appointmentWindow');
  const [pauseAppointment, setPauseAppointment] = useState(false); // State for the toggle button
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [initialFormState, setInitialFormState] = useState(null); // Store initial form state for comparison
  const [isFormChanged, setIsFormChanged] = useState(false); // Track if the form has been changed
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false); // State for delete confirmation dialog
  const [accountErrorMsg, setAccountErrorMsg] = useState(''); // New state for account access error message
  const [hasAccountAccessError, setHasAccountAccessError] = useState(false); // Track if there's an account access error
  const [formData, setFormData] = useState({
    availability: {},
    unavailableDates: [],
    appointmentDuration: '',
    bookingTitle: '',
    bookingdescription: '',
    availableDatesOption: 'future',
    numberOfDays: '',
    startDate: null,
    endDate: null,
    appointmentType: 'single', // Default to "Single Appointment"
    remainderFields: [] // Initialize remainderFields array
  });
  const [dropdownOptions, setDropdownOptions] = useState([]); // Will store {id, name} objects
  const [selectedOption, setSelectedOption] = useState(''); // State for selected dropdown value
  const [selectedCalendar, setSelectedCalendar] = useState(null); // Track the selected calendar
  const [isAddCalendarModalOpen, setIsAddCalendarModalOpen] = useState(false);
  const [isEditingName, setIsEditingName] = useState(false);
  const [categories, setCategories] = useState([]);
  const [canCreateCalendar, setCanCreateCalendar] = useState(false); // Track user's calendar creation permission
  const [userRole, setUserRole] = useState(null); // Track user's role for conditional rendering
  const [isSaving, setIsSaving] = useState(false);
  // ...existing code...


  const token = localStorage.getItem('token');

  // Only fetch calendars when acctId is loaded
  useEffect(() => {
    if (acctId && !acctIdLoading) {
      fetchCalendarsFromDatabase();
    }
  }, [acctId, acctIdLoading]);


  useEffect(() => {
    // Check URL parameters for OAuth errors
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');

    if (error) {
      if (error === 'access_denied') {
        showError('Google Calendar authentication was cancelled.');
      } else {
        showError(`Authentication error: ${error}`);
      }

      // Clean up URL parameters
      window.history.replaceState({}, document.title, window.location.pathname);
    }
    // Check if we're returning from OAuth flow
    const authReturnUrl = localStorage.getItem('googleAuthReturnUrl');
    if (authReturnUrl) {
      // Redirect to the saved return URL to restore correct account/calendar context
      localStorage.removeItem('googleAuthReturnUrl');
      if (window.location.href !== authReturnUrl) {
        window.location.href = authReturnUrl;
      }
    }
  }, [showError]);

  const location = useLocation();
  const accountFromUrl = getAcctNoFromUrl(location.search);

  // Fetch acctId only once when accountNo changes, and set loading state
  useEffect(() => {
    // Removed local acctIdLoading logic, now handled by Dashboard context
    // If you need to fetch or reset state on acctId change, use acctId and acctIdLoading from context
    // Utility: Switch account and update URL, localStorage, and trigger re-fetch
    const switchAccount = (newAcctNo) => {
      if (!newAcctNo) return;
      // Update URL
      const url = new URL(window.location.href);
      url.searchParams.set('acc', newAcctNo);
      window.history.replaceState({}, '', url);
      // Update localStorage
      localStorage.setItem('acctNo', newAcctNo);
      // Trigger re-fetch by updating location.search (React Router)
      window.dispatchEvent(new Event('accountUpdated'));
    };
    // Listen for account changes via custom events (from dashboard)
    const handleAccountVerified = () => {
      // Removed call to fetchAcctIdAndInitPanel; logic now handled by Dashboard context
    };
    window.addEventListener('accountVerified', handleAccountVerified);
    window.addEventListener('accountUpdated', handleAccountVerified);
    return () => {
      window.removeEventListener('accountVerified', handleAccountVerified);
      window.removeEventListener('accountUpdated', handleAccountVerified);
    };
  }, [location.search, acc, accountFromUrl]);



  // Fetch categories for the account (move to top-level)
  const fetchCategories = async () => {
    // Only fetch if categories are not already loaded
    if (categories && categories.length > 0) return;
    try {
      const id = acctId || localStorage.getItem('acctId');
      if (!id) return;
      const token = localStorage.getItem('token');
      const response = await fetch('/api/ui/appointment/gCal/getCategories', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ acctId: id }),
      });
      if (!response.ok) return;
      const responseData = await response.json();
      if (responseData.success && Array.isArray(responseData.data)) {
        setCategories(responseData.data);
      } else {
        setCategories([]);
      }
    } catch (error) {
      setCategories([]);
    }
  };

  const fetchCalendarsFromDatabase = async () => {
    setIsCalendarsLoading(true);
    setIsProfileImageLoading(true);
    setIsSaveEnabled(false);
    if (!acctId) {
      setIsPanelLoading(false);
      setIsCalendarsLoading(false);
      return;
    }
    try {
      // Use acctId from state only
      const userId = localStorage.getItem('userId');
      if (!acctId || !userId) {
        setIsPanelLoading(false);
        setIsCalendarsLoading(false);
        return;
      }
      // Fetch calendars using acctId
      const token = localStorage.getItem('token');
      const response = await fetch('/api/ui/appointment/gCal/getCalendars', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ acctId, userId }),
      });
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      let calendars = data.calendars.map((calendar) => ({
        id: calendar._id,
        name: calendar.calendarName || calendar.calendarId,
        categoryId: calendar.categoryId || ''
      }));
      setDropdownOptions(calendars);

      // --- Calendar selection persistence logic ---
      // Try to get last selected calendar for this account from localStorage
      let calendarToFetch = null;
      let localStorageKey = `selectedCalendar_${acctId}`;
      let storedCalendarId = localStorage.getItem(localStorageKey);
      if (storedCalendarId && calendars.some(cal => cal.id === storedCalendarId)) {
        calendarToFetch = storedCalendarId;
        setSelectedOption(storedCalendarId);
        setSelectedCalendar(storedCalendarId);
      } else if (calendars.length > 0) {
        calendarToFetch = calendars[0].id;
        setSelectedOption(calendars[0].id);
        setSelectedCalendar(calendars[0].id);
      }
      // Only fetch if we have a valid calendar ID and it's different from the last fetched one
      if (calendarToFetch && calendarToFetch !== lastFetchedCalendarRef.current && acctId) {
        fetchCalendarData(calendarToFetch);
      } else {
        console.warn('[fetchCalendarsFromDatabase] Skipped fetchCalendarData: calendarToFetch or acctId missing', { calendarToFetch, acctId });
      }
      setCanCreateCalendar(true);
    } catch (error) {
      showError('Error fetching calendars from the database');
    } finally {
      setIsPanelLoading(false);
      setIsCalendarsLoading(false);
    }
  }
  useEffect(() => {
    if (acctId) {
      fetchCategories();
    }
  }, [acctId]); useEffect(() => {
    if (!isFormChanged) {
      setIsSaveEnabled(false);
    }
  }, [isFormChanged]);
  const handleConnectClick = () => {
    // Debug: log acctId and account number at click time
    const accountNo = acc || accountFromUrl;
    let effectiveAcctId = acctId;
    const tryApiLookup = async () => {
      // Try to re-lookup acctId from API if not found in state or localStorage
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      if (!userId || !token) return null;
      try {
        const response = await fetch(`/api/ui/appointment/gCal/verifyAccountAccess/${accountNo}`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) return null;
        const data = await response.json();
        if (data.success && data.account && data.account.acctId) {
          return data.account.acctId;
        }
      } catch (e) {
        console.error('[handleConnectClick] Error in API fallback for acctId:', e);
      }
      return null;
    };
    const proceed = async () => {
      // Use acctId from state if available
      if (!effectiveAcctId) {
        // Fallback: Try to get acctId from localStorage accounts
        const accountsJson = localStorage.getItem('accounts');
        if (accountsJson) {
          try {
            const accounts = JSON.parse(accountsJson);
            const currentAccount = accounts.find(acc => acc.acctNo === accountNo || acc.accountNo === accountNo);
            if (currentAccount) {
              effectiveAcctId = currentAccount.acctId;
            }
          } catch (e) {
            console.error('[handleConnectClick] Error parsing accounts for fallback acctId:', e);
          }
        }
      }
      // Final fallback: Try API only if still not found
      if (!effectiveAcctId) {
        effectiveAcctId = await tryApiLookup();
      }
      if (!effectiveAcctId) {
        showError('No account ID found');
        return;
      }
      // ...existing code for redirect...
      const isLocalEnvironment = window.location.hostname === 'localhost';
      const apiBaseUrl = isLocalEnvironment ? 'http://localhost:8083' : (process.env.REACT_APP_API_URL || '');
      const oauthPath = process.env.REACT_APP_GOOGLE_CALENDAR_OAUTH_PATH || '/api/appointment/gCal/oAuth2/redirect';
      const calendarId = selectedOption || 'Calendar1';
      const defaultSettings = {
        mode: true,
        appointmentType: false,
        sameDayAppointment: false,
        availability: {
          days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
          time: {
            'Mon': [{ start: '09:00', end: '17:00' }],
            'Tue': [{ start: '09:00', end: '17:00' }],
            'Wed': [{ start: '09:00', end: '17:00' }],
            'Thu': [{ start: '09:00', end: '17:00' }],
            'Fri': [{ start: '09:00', end: '17:00' }],
          }
        }
      };
      localStorage.setItem('defaultCalendarSettings', JSON.stringify(defaultSettings));
      const redirectUrl = `${apiBaseUrl}${oauthPath}/${effectiveAcctId}?calendar=${calendarId}`;
      localStorage.setItem('googleAuthReturnUrl', window.location.href);
      // Save the selected calendar in the URL before redirecting for OAuth
      const url = new URL(window.location.href);
      url.searchParams.set('calendar', calendarId);
      window.history.replaceState({}, '', url);
      window.location.href = redirectUrl;
    };
    proceed();

    // In development, use the proxy specified in package.json instead of the env variable
    const isLocalEnvironment = window.location.hostname === 'localhost';
    const apiBaseUrl = isLocalEnvironment ? 'http://localhost:8083' : (process.env.REACT_APP_API_URL || '');
    const oauthPath = process.env.REACT_APP_GOOGLE_CALENDAR_OAUTH_PATH || '/api/appointment/gCal/oAuth2/redirect';
    const calendarId = selectedOption || 'Calendar1';



    // Set default settings in localStorage when connecting
    const defaultSettings = {
      mode: true, // Online appointment (Google Meet)
      appointmentType: false, // Single appointment
      sameDayAppointment: false, // Not allowing same day appointments by default
      availability: {
        days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
        time: {
          'Mon': [{ start: '09:00', end: '17:00' }],
          'Tue': [{ start: '09:00', end: '17:00' }],
          'Wed': [{ start: '09:00', end: '17:00' }],
          'Thu': [{ start: '09:00', end: '17:00' }],
          'Fri': [{ start: '09:00', end: '17:00' }],
        }
      }
    }; localStorage.setItem('defaultCalendarSettings', JSON.stringify(defaultSettings));

    // Construct the redirect URL
    const redirectUrl = `${apiBaseUrl}${oauthPath}/${acctId}?calendar=${calendarId}`;

    // Save the current URL to return to after authentication
    localStorage.setItem('googleAuthReturnUrl', window.location.href);

    // Navigate to the OAuth URL
    window.location.href = redirectUrl;
  };

  const handleDisconnectClick = async () => {
    openConfirmationDialog();
  };

  const confirmDisconnect = async () => {
    try {
      if (!acctId) {
        showError('No account ID found.');
        return;
      }

      // Then proceed with disconnection
      const token = localStorage.getItem('token');
      const response = await fetch('/api/ui/appointment/gCal/disconnectCalendar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ acctId, calendarId: selectedCalendar }),
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      setIsConnected(false);
      setEmail(null);
      setGooglePicture(null);
      showSuccess('Google Calendar Disconnected');
    } catch (error) {
      showError('Error disconnecting from Google Calendar');
    } finally {
      closeConfirmationDialog();
    }
  };

  const handleToggleChange = async () => {
    setIsSaving(true);
    const newPauseAppointmentState = !pauseAppointment;
    setPauseAppointment(newPauseAppointmentState);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/ui/appointment/gCal/savePauseState', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          acctId,
          calendarId: selectedCalendar,
          pauseAppointment: newPauseAppointmentState
        }),
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      await response.json();
      if (newPauseAppointmentState)
        showSuccess('Appointments are temporarily paused');
      else
        showSuccess('Appointments are now open');
    } catch (error) {
      showError('Error updating pause state');
      setPauseAppointment(prevState => !prevState);
    } finally {
      setIsSaving(false);
    }
  }; const handleFieldChange = () => {

    setIsFormChanged(true);
    setIsSaveEnabled(true);
  };

  const handleFormDataChange = (field, value) => {

    // Update form data
    setFormData(prevFormData => {
      const newFormData = {
        ...prevFormData,
        [field]: value
      };

      // Check if the form data is different from the initial state
      if (initialFormState) {
        // Need to handle special case for dates
        const formDataForComparison = {
          ...newFormData,
          startDate: newFormData.startDate ? newFormData.startDate.toISOString() : null,
          endDate: newFormData.endDate ? newFormData.endDate.toISOString() : null,
          unavailableDates: newFormData.unavailableDates.map(date => date ? date.toISOString() : null)
        };

        const currentFormDataStr = JSON.stringify(formDataForComparison);
        const initialFormDataStr = JSON.stringify(initialFormState);

        const hasChanged = currentFormDataStr !== initialFormDataStr;


        setIsFormChanged(hasChanged);
        setIsSaveEnabled(hasChanged);
      } else {
        // If no initial state yet, enable save
        setIsFormChanged(true);
        setIsSaveEnabled(true);
      }

      return newFormData;
    });
  };

  const handleSaveClick = async () => {
    // Validation


    const hasTimeSlotsForAtLeastOneDay = Object.values(formData.availability.time).some(slots => slots.length > 0);

    if (!hasTimeSlotsForAtLeastOneDay) {
      showError('Please select at least one time slot for at least one day.');
      return;
    }

    if (formData.availableDatesOption === 'range') {
      if (!formData.startDate || !formData.endDate) {
        showError('Start date and end date should not be empty.');
        return;
      }
    }

    if (formData.availableDatesOption === 'rolling') {
      if (!formData.numberOfDays) {
        showError('Number of days should not be empty.');
        return;
      }
    }

    setIsSaving(true);

    // STEP 1: Upload profile image first if one exists
    let updatedProfileImageUrl = googlePicture;


    if (newProfileImage) {
      try {
        const formData = new FormData();
        formData.append('image', newProfileImage);
        formData.append('acctId', acctId);
        formData.append('calendarId', selectedCalendar);
        const selectedCalendarObj = dropdownOptions.find(opt => opt.id === selectedCalendar);
        if (selectedCalendarObj && selectedCalendarObj.categoryId) {
          formData.append('categoryId', selectedCalendarObj.categoryId);
        }
        const token = localStorage.getItem('token');
        const imageResponse = await fetch('/api/ui/appointment/gCal/uploadProfileImage', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: formData
        });

        if (!imageResponse.ok) {
          throw new Error(`Image upload failed: ${imageResponse.status}`);
        }

        const imageData = await imageResponse.json();

        // Fix: Check for imageUrl in the data property
        if (imageData.success && imageData.data && imageData.data.imageUrl) {
          updatedProfileImageUrl = imageData.data.imageUrl;


        } else {
          throw new Error('Invalid response from image upload service');
        }
      } catch (error) {

        showError('Failed to upload profile image. Aborting save operation.');
        setIsPanelLoading(false);
        return; // Stop the save process if image upload fails
      }
    }

    // STEP 2: Proceed with saving data using the new image URL
    try {
      // Map formData.availability to the required structure
      const availability = {
        time: formData.availability.time ? Object.keys(formData.availability.time).reduce((acc, day) => {
          if (formData.availability.time[day]?.length > 0) {
            acc[day] = formData.availability.time[day].map(appointment => ({
              start: appointment.start,
              end: appointment.end
            }));
          }
          return acc;
        }, {}) : {}
      };

      // Only include days in availability.days if they have time slots in availability.time
      availability.days = formData.availability.days?.filter(day =>
        availability.time[day] && availability.time[day].length > 0
      ) || [];

      // Ensure remainderFields is defined before mapping
      const transformedRemainders = (formData.remainderFields || []).map(remainder => {
        let minutes;
        if (remainder.remainderType === 'days') {
          minutes = remainder.remainderValue * 24 * 60;
        } else if (remainder.remainderType === 'hours') {
          minutes = remainder.remainderValue * 60;
        } else {
          minutes = remainder.remainderValue;
        }
        return {
          method: remainder.type,
          minutes: parseInt(minutes, 10)
        };
      });
      // Filter out past unavailable dates before saving
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const filteredUnavailableDates = formData.unavailableDates.filter(date => {
        if (!date) return false;
        const d = date instanceof Date ? date : new Date(date);
        d.setHours(0, 0, 0, 0);
        return d >= today;
      });
      let settings = {
        timeZone,
        pauseAppointment,
        type: formData.availableDatesOption,
        slotDurationInMins: formData.appointmentDuration,
        unAvailability: {
          dates: filteredUnavailableDates.map(date => date ? date.toLocaleDateString('en-CA') : null).filter(date => date !== null)
        },
        availability: availability,
        onlineAppointment: formData.mode === true,
        allowMultipleAppointments: formData.appointmentType,
        sameDayAppointment: formData.sameDayAppointment === true,
        remainder: transformedRemainders,
        calendarIdcopy: formData.calendarIdcopy || 'primary'
      };

      // Conditionally add either startDate & endDate or rollingDays
      if (formData.availableDatesOption === 'range') {
        settings.startDate = formData.startDate ? formData.startDate.toLocaleDateString('en-CA') : null;
        settings.endDate = formData.endDate ? formData.endDate.toLocaleDateString('en-CA') : null;
      } else if (formData.availableDatesOption === 'rolling') {
        settings.rollingDays = formData.numberOfDays;
      }

      const dataToSave = {
        acctId,
        calendarId: selectedCalendar,
        googleCal: {
          token: {},
          settings: settings
        }
      };

      const token = localStorage.getItem('token');
      const response = await fetch('/api/ui/appointment/gCal/saveSettings', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(dataToSave),
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      const result = await response.json();

      // Update UI with new profile image
      if (newProfileImage && updatedProfileImageUrl !== googlePicture) {
        setGooglePicture(updatedProfileImageUrl);
      }

      // Reset image states
      setNewProfileImage(null);
      setNewProfileImagePreview(null);

      showSuccess('Appointment saved successfully');
    } catch (error) {
      showError('Error saving settings');
    } finally {
      setIsSaving(false);
      setIsSaveEnabled(false);
      setIsFormChanged(false);

      // Update initialFormState with the current form data
      const formDataCopy = JSON.parse(JSON.stringify({
        ...formData,
        startDate: formData.startDate ? formData.startDate.toISOString() : null,
        endDate: formData.endDate ? formData.endDate.toISOString() : null,
        unavailableDates: formData.unavailableDates.map(date => date ? date.toISOString() : null)
      }));
      setInitialFormState(formDataCopy);
    }
  };

  const handleProfileImageClick = () => {
    fileInputRef.current?.click();
  };
  const handleProfileImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.match('image.*')) {
      showError('Please select an image file');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      showError('Image size should be less than 5MB');
      return;
    }

    // Show preview immediately from original file
    const previewUrl = URL.createObjectURL(file);
    setNewProfileImagePreview(previewUrl);
    setIsSaveEnabled(true);
    setIsProfileImageLoading(true);

    // Now compress and upload in background
    try {
      const { file: compressedFile } = await import('../../utils/imageCompressor').then(mod => mod.compressAndConvertToBase64(file, {
        targetBytes: 95 * 1024, // Target 95KB to ensure we stay under 100KB
        compressionThreshold: 0,
        allowedOverhead: 1.05, // Strict overhead limit for profile images
        maxWidthOrHeight: 1024, // Smaller dimensions for profile images
        initialQuality: 0.80, // Lower initial quality for profile images
        maxAttempts: 6 // More attempts for better optimization
      }));
      setNewProfileImage(compressedFile);
      // Await upload and only stop loading after upload completes
      await uploadProfileImage(compressedFile);
      setTimeout(() => URL.revokeObjectURL(previewUrl), 2000);
    } catch (err) {
      showError('Failed to compress or upload profile image.');
    }
  };

  // New function to handle immediate image upload
  const uploadProfileImage = async (imageFile) => {
    if (!imageFile || !selectedCalendar) return;

    setIsPanelLoading(true);
    try {
      const formData = new FormData();
      formData.append('image', imageFile);
      formData.append('acctId', acctId);
      formData.append('calendarId', selectedCalendar);
      const selectedCalendarObj = dropdownOptions.find(opt => opt.id === selectedCalendar);
      if (selectedCalendarObj && selectedCalendarObj.categoryId) {
        formData.append('categoryId', selectedCalendarObj.categoryId);
      }
      const token = localStorage.getItem('token');
      const response = await fetch('/api/ui/appointment/gCal/uploadProfileImage', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error(`Image upload failed: ${response.status}`);
      }

      const imageData = await response.json();

      if (imageData.success && imageData.data && imageData.data.imageUrl) {
        setGooglePicture(imageData.data.imageUrl);
        showSuccess('Profile image updated successfully');
      } else {
        throw new Error('Invalid response from image upload service');
      }
    } catch (error) {
      showError('Failed to upload profile image');
    } finally {
      setIsPanelLoading(false);
    }
  };


  const openConfirmationDialog = () => {
    setIsConfirmationOpen(true);
  };

  const closeConfirmationDialog = () => {
    setIsConfirmationOpen(false);
  };

  const handleDeleteCalendarClick = () => {
    setIsDeleteConfirmationOpen(true);
  };

  const closeDeleteConfirmationDialog = () => {
    setIsDeleteConfirmationOpen(false);
  };

  const confirmDeleteCalendar = async () => {
    setIsPanelLoading(true);
    try {
      // First, delete the calendar

      const response = await fetch('/api/ui/appointment/gCal/deleteCalendar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ acctId, calendarId: selectedCalendar }),
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      // Then, make an additional API call to remove calendar references from all users
      const cleanupResponse = await fetch('/api/ui/appointment/gCal/removeCalendarFromUsers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ calendarId: selectedCalendar }),
      });

      if (!cleanupResponse.ok) {
        console.error('Failed to clean up user references:', await cleanupResponse.text());
        // Continue execution even if cleanup fails, but log the error
      }

      setDropdownOptions(prev => prev.filter(cal => cal.id !== selectedCalendar));

      if (dropdownOptions.length > 1) {
        const newSelection = dropdownOptions.find(cal => cal.id !== selectedCalendar);
        setSelectedOption(newSelection.id);
        setSelectedCalendar(newSelection.id);

        // Reset the last fetched calendar ref to ensure we load fresh data for the newly selected calendar
        lastFetchedCalendarRef.current = null;
        fetchCalendarData(newSelection.id);
      } else {
        setSelectedOption('');
        setSelectedCalendar(null);
        lastFetchedCalendarRef.current = null;
      }

      showSuccess('Calendar deleted successfully');
    } catch (error) {
      showError('Error deleting calendar');
    } finally {
      setIsPanelLoading(false);
      closeDeleteConfirmationDialog();
    }
  };
  const fetchCalendarData = async (calendarId) => {
    // Always get acctId from acctNo in URL
    const urlParams = new URLSearchParams(window.location.search);
    const accountNo = urlParams.get('acc') || acc;

    if (!calendarId || !acctId) {
      console.warn('[fetchCalendarData] Missing calendarId or acctId', { calendarId, acctId });
      setIsPanelLoading(false);
      setIsCalendarsLoading(false);
      setIsProfileImageLoading(false);
      setIsSaveEnabled(false);
      isFetchingCalendarRef.current = false;
      return;
    }
    // Get acctId from API
    let currentAcctId = null;
    const token = localStorage.getItem('token');
    if (!token) {
      console.warn('[fetchCalendarData] No token found');
      showError('No token found. Please log in again.');
      setIsPanelLoading(false);
      setIsCalendarsLoading(false);
      setIsProfileImageLoading(false);
      setIsSaveEnabled(false);
      isFetchingCalendarRef.current = false;
      return;
    }
    try {
      // Check if we're already fetching this calendar or if it's the same as the last fetched one
      if (isFetchingCalendarRef.current || (calendarId === lastFetchedCalendarRef.current && calendarId !== null)) {
        setIsPanelLoading(false);
        setIsCalendarsLoading(false);
        setIsProfileImageLoading(false);
        setIsSaveEnabled(false);
        return;
      }
      isFetchingCalendarRef.current = true;
      lastFetchedCalendarRef.current = calendarId;

      setIsPanelLoading(true);
      setIsSaveEnabled(false);
      setGooglePicture(null);
      setNewProfileImage(null);
      setNewProfileImagePreview(null);
      setIsProfileImageLoading(true);

      // Now fetch calendar data with the correct acctId
      const response = await fetch('/api/ui/appointment/gCal/getCalendarData', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ acctId, calendarId }),
      });
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      if (data.success && data.tokenExists) {
        const settings = data.settings || {};
        const defaultSettings = JSON.parse(localStorage.getItem('defaultCalendarSettings') || '{}');
        const isNewConnection = !settings.availability?.days?.length;

        setIsConnected(true);
        setIsConnectionStatusReady(true);
        setEmail(settings.email);
        if (settings.googlePicture) {
          const timestamp = new Date().getTime();
          const imageUrl = settings.googlePicture.includes('?')
            ? `${settings.googlePicture}&t=${timestamp}`
            : `${settings.googlePicture}?t=${timestamp}`;
          setGooglePicture(imageUrl);
        } else {
          setIsProfileImageLoading(false);
        }
        localStorage.setItem("isConnected", "true");
        const availabilityDays = isNewConnection ? defaultSettings.availability?.days : (settings.availability?.days || []);
        const availabilityTime = isNewConnection && defaultSettings.availability?.time ?
          defaultSettings.availability.time :
          (settings.availability?.time || {});
        const mappedAvailability = Object.keys(availabilityTime).reduce((acc, day) => {
          acc[day] = availabilityTime[day].map(appointment => ({
            start: appointment.start,
            end: appointment.end
          }));
          return acc;
        }, {});
        const unavailableDates = settings.unAvailability?.dates?.map(date =>
          new Date(date)
        ) || [];
        const remainderFields = settings.remainder?.map(rem => {
          let remainderValue, remainderType;
          if (rem.minutes >= 24 * 60) {
            remainderValue = Math.floor(rem.minutes / (24 * 60));
            remainderType = 'days';
          } else if (rem.minutes >= 60) {
            remainderValue = Math.floor(rem.minutes / 60);
            remainderType = 'hours';
          } else {
            remainderValue = rem.minutes;
            remainderType = 'minutes';
          }
          return {
            type: rem.method || '',
            remainderType,
            remainderValue: remainderValue.toString()
          };
        }) || [];
        const newFormData = {
          availability: {
            days: availabilityDays,
            time: mappedAvailability,
            waSlots: settings.availability?.waSlots || {}
          },
          pauseAppointment: settings.pauseAppointment || false,
          appointmentDuration: settings.slotDurationInMins?.toString() || '60',
          unavailableDates: unavailableDates,
          availableDatesOption: settings.type || 'future',
          numberOfDays: settings.rollingDays?.toString() || '',
          startDate: settings.startDate ? new Date(settings.startDate) : null,
          endDate: settings.endDate ? new Date(settings.endDate) : null,
          mode: isNewConnection ? defaultSettings.mode : (settings.onlineAppointment === true),
          appointmentType: isNewConnection ? defaultSettings.appointmentType : settings.allowMultipleAppointments,
          sameDayAppointment: isNewConnection ? defaultSettings.sameDayAppointment : (settings.sameDayAppointment === true),
          remainderFields: remainderFields,
          calendarIdcopy: settings.calendarId || 'primary'
        };

        setFormData(newFormData);
        if (isNewConnection && Object.keys(defaultSettings).length > 0) {
          await saveDefaultSettings(calendarId, defaultSettings);
        }
        setPauseAppointment(settings.pauseAppointment || false);
        setTimeout(() => {
          const formDataCopy = JSON.parse(JSON.stringify({
            ...newFormData,
            startDate: newFormData.startDate ? newFormData.startDate.toISOString() : null,
            endDate: newFormData.endDate ? newFormData.endDate.toISOString() : null,
            unavailableDates: newFormData.unavailableDates.map(date => date ? date.toISOString() : null)
          }));
          setInitialFormState(formDataCopy);
          setIsFormChanged(false);
        }, 100);
      } else {
        setIsConnected(false);
        setIsConnectionStatusReady(true);
        localStorage.removeItem("isConnected");
        setIsProfileImageLoading(false);
      }
    } catch (error) {
      showError('Error loading calendar data');
      setIsProfileImageLoading(false);
      setIsConnectionStatusReady(true);
    } finally {
      setIsPanelLoading(false);
      setIsCalendarsLoading(false);
      setIsSaveEnabled(false);
      isFetchingCalendarRef.current = false;
    }
  };

  // Helper function to save default settings when a new calendar is connected
  const saveDefaultSettings = async (calendarId, defaultSettings) => {
    try {
      // Prepare the settings object with default values
      const settings = {
        pauseAppointment: false,
        calendarIdcopy: calendarIdcopy || 'primary',
        type: 'future',
        slotDurationInMins: '60',
        unAvailability: { dates: [] },
        availability: {
          days: defaultSettings.availability.days,
          time: defaultSettings.availability.time
        },
        timeZone,
        onlineAppointment: defaultSettings.mode,
        allowMultipleAppointments: defaultSettings.appointmentType,
        sameDayAppointment: defaultSettings.sameDayAppointment || false,
        remainder: []
      };

      // Use acctId from state
      const effectiveAcctId = acctId;
      const userId = localStorage.getItem('userId');
      if (!effectiveAcctId || !userId) {
        showError('Account or user information is missing. Please reload and try again.');
        return;
      }
      const dataToSave = {
        acctId: effectiveAcctId,
        calendarId: calendarId,
        googleCal: {
          token: {},
          settings: settings
        }
      };
      const token = localStorage.getItem('token');
      await fetch('/api/ui/appointment/gCal/saveSettings', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(dataToSave),
      });

      // Clear the default settings after saving
      localStorage.removeItem('defaultCalendarSettings');
    } catch (error) {
      console.error('Error saving default settings:', error);
      // Don't show an error to the user, as this is a background operation
    }
  }; const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    if (!selectedValue || selectedValue === selectedCalendar) {
      return; // Prevent duplicate selection of the same calendar
    }

    // Persist selected calendar for this account in localStorage
    if (acctId && selectedValue) {
      localStorage.setItem(`selectedCalendar_${acctId}`, selectedValue);
    }

    // Clear current states
    setGooglePicture(null);
    setEmail(null);

    // Show loading indicators immediately to give user feedback
    setIsPanelLoading(true);
    setIsCalendarsLoading(true);

    // Reset form tracking states
    setIsSaveEnabled(false);
    setIsFormChanged(false);
    setInitialFormState(null);

    // Update selected calendar state
    setSelectedOption(selectedValue);
    setSelectedCalendar(selectedValue);

    // Update the URL with the selected calendar for tab isolation and deep linking, but only if different
    const url = new URL(window.location.href);
    const currentCalendarInUrl = url.searchParams.get('calendar');
    if (currentCalendarInUrl !== selectedValue) {
      url.searchParams.set('calendar', selectedValue);
      window.history.replaceState({}, '', url);
    }

    // Reset the last fetched calendar ref to ensure we fetch fresh data
    lastFetchedCalendarRef.current = null;
    isFetchingCalendarRef.current = false; // Reset fetch flag

    // Fetch calendar data immediately
    fetchCalendarData(selectedValue);
  };

  // Effect to show error notification when account access error occurs
  // Prevent repeated effect execution by using a ref
  const errorHandledRef = useRef(false);
  useEffect(() => {
    if (hasAccountAccessError && accountErrorMsg && !errorHandledRef.current) {
      showError(accountErrorMsg);
      errorHandledRef.current = true;
      setTimeout(() => {
        setAccountErrorMsg((msg) => (msg !== '' ? '' : msg));
        setHasAccountAccessError((flag) => (flag ? false : flag));
        errorHandledRef.current = false;
      }, 15000); // Keep the error displayed for 15 seconds
    }
    // Reset the ref if a new error is set
    if (!hasAccountAccessError || !accountErrorMsg) {
      errorHandledRef.current = false;
    }
  }, [hasAccountAccessError, accountErrorMsg, showError]);

  // Place these functions before the return statement and before any usage

  const handleAddCalendar = async () => {
    setIsPanelLoading(true);
    try {
      if (!acctId) {
        showError('Account not found. Cannot load categories.');
        setIsPanelLoading(false);
        return;
      }
      // Always fetch categories before opening dialog
      await fetchCategories();
      setIsAddCalendarModalOpen(true);
    } catch (e) {
      setCategories([]);
      showError('Failed to load categories');
    } finally {
      setIsPanelLoading(false);
    }
  };

  const handleCreateCalendar = async (calendarData) => {
    if (!calendarData.name.trim()) {
      showError('Please enter a calendar name');
      return;
    }
    if (!canCreateCalendar) {
      showError('You do not have permission to create a calendar.');
      return;
    }
    setIsPanelLoading(true);
    try {
      const userId = localStorage.getItem('userId');
      if (!acctId) {
        showError('Account not found. Cannot create calendar.');
        setIsPanelLoading(false);
        return;
      }
      const response = await fetch('/api/ui/appointment/gCal/addCalendar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          acctId,
          userId,
          calendarName: calendarData.name.trim(),
          categoryId: calendarData.categoryId || null
        }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || `HTTP error! Status: ${response.status}`);
      }
      const newCalendar = {
        id: data._id,
        name: calendarData.name.trim()
      };
      // ...existing code for updating admin users, UI, and localStorage...
      setGooglePicture(null);
      setEmail(null);
      setIsConnected(false);
      setDropdownOptions(prev => [...prev, newCalendar]);
      setSelectedOption(newCalendar.id);
      setSelectedCalendar(newCalendar.id);
      if (acctId && newCalendar.id) {
        localStorage.setItem(`selectedCalendar_${acctId}`, newCalendar.id);
      }
      const url = new URL(window.location.href);
      const currentCalendarInUrl = url.searchParams.get('calendar');
      if (currentCalendarInUrl !== newCalendar.id) {
        url.searchParams.set('calendar', newCalendar.id);
        window.history.replaceState({}, '', url);
      }
      lastFetchedCalendarRef.current = null;
      showSuccess(data.message || `Calendar "${calendarData.name}" added successfully`);
      setIsAddCalendarModalOpen(false);
      await fetchCalendarData(newCalendar.id);
      const customEvent = new CustomEvent('calendarListUpdated', { detail: { calendarId: newCalendar.id, operation: 'add' } });
      window.dispatchEvent(customEvent);
    } catch (error) {
      showError(error.message);
    } finally {
      setIsPanelLoading(false);
    }
  };

  const handleUpdateCalendarId = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/ui/appointment/gCal/updateCalendarId', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          acctId,
          calendarId: selectedCalendar,
          newCalendarId: formData.calendarIdcopy
        })
      });
      if (response.ok) {
        showSuccess('Calendar ID updated successfully');
      } else {
        showError('Failed to update Calendar ID');
      }
    } catch (error) {
      showError('Error updating Calendar ID');
    } finally {
      setIsPanelLoading(false);
      setIsEditingCalendarId(false);
      setIsFormChanged(false);
      setIsSaveEnabled(false);
    }
  };

  const handleCalendarNameEdit = async (newName) => {
    if (!newName.trim() || newName === selectedCalendar) {
      setIsEditingName(false);
      return;
    }
    setIsPanelLoading(true);
    try {
      const response = await fetch('/api/ui/appointment/gCal/updateCalendarName', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          acctId,
          calendarId: selectedCalendar,
          newName: newName.trim()
        }),
      });
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      setDropdownOptions(prev => prev.map(cal =>
        cal.id === selectedCalendar ? { ...cal, name: newName.trim() } : cal
      ));
      showSuccess('Calendar name updated successfully');
    } catch (error) {
      showError('Error updating calendar name');
    } finally {
      setIsPanelLoading(false);
      setIsEditingName(false);
    }
  };



  if (acctIdLoading || isCalendarsLoading || !formData || !formData.availability) {
    // Show skeleton placeholders in the same layout as the real components
    return (
      <div className="panel border border-gray-200 bg-white shadow-lg rounded-xl p-6 mt-5 w-full mx-auto relative hover:shadow-xl transition-shadow duration-300" style={{ minHeight: '100vh', height: '100vh', maxHeight: '100vh', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
        <div className="grid grid-cols-1 sm:grid-cols-2 items-center gap-x-12">
          {/* Profile and Connect button section skeleton */}
          <div className="flex flex-col space-y-3">
            <div className="flex items-center space-x-3">
              {/* Profile image skeleton - booking style with user icon */}
              <div className="relative group cursor-pointer">
                <div className="w-24 h-16 bg-gray-200 animate-pulse border border-gray-300 rounded-lg flex items-center justify-center">
                  {/* User icon for placeholder */}
                  <svg className="w-10 h-10 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                    <circle cx="12" cy="8" r="4" />
                    <path d="M4 20c0-4 8-4 8-4s8 0 8 4v2H4v-2z" />
                  </svg>
                </div>
              </div>
              <div className="flex flex-col">
                {/* Calendar name skeleton */}
                <div className="w-32 h-6 rounded bg-gray-200 animate-pulse mb-2" />
                {/* Email skeleton */}
                <div className="w-40 h-5 rounded bg-gray-200 animate-pulse mb-1" />
                {/* Timezone skeleton */}
                <div className="w-24 h-4 rounded bg-gray-200 animate-pulse" />
              </div>
            </div>
          </div>
          {/* Connect/Disconnect button skeleton */}
          <div className="flex justify-end items-center">
            <div className="w-36 h-10 rounded bg-gray-200 animate-pulse" />
          </div>
        </div>
        {/* Appointment Window skeleton - field placeholders */}
        <div className="border-t pt-4 mt-4">
          <div className="flex flex-col gap-4 p-6">
            {/* Title field skeleton */}
            <div className="w-2/3 h-8 bg-gray-200 animate-pulse rounded" />
            {/* Description field skeleton */}
            <div className="w-full h-6 bg-gray-200 animate-pulse rounded" />
            {/* Date picker skeleton */}
            <div className="w-1/2 h-8 bg-gray-200 animate-pulse rounded" />
            {/* Time slot skeletons */}
            <div className="flex gap-2">
              <div className="w-24 h-8 bg-gray-200 animate-pulse rounded" />

            </div>
          </div>
        </div>
      </div>
    );
  }


  return (
    <>
      <NotificationComponent />

      {/* Show LoadingMask overlay only when saving to database */}
      <LoadingMask loading={isSaving} />

      {/* Always render the modal/dialog so it can be opened by event, even if there are no calendars */}
      {isAppointmentSetupOpen && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30" aria-hidden="true" />
          <div className="fixed inset-0 flex items-center justify-center p-4 z-50">
            <div className="w-[80vw] max-w-[80vw] min-w-[700px] h-[80vh] max-h-[80vh] transform overflow-hidden rounded-lg bg-white p-10 text-left align-middle shadow-2xl transition-all relative flex flex-col" style={{ minHeight: '400px', maxWidth: '80vw', height: '80vh', maxHeight: '80vh', overflowY: 'auto' }}>
              <div className="relative pt-0">
                <button
                  type="button"
                  onClick={() => setIsAppointmentSetupOpen(false)}
                  className="absolute right-1 p-1 rounded-full bg-black hover:bg-gray-800 transition-colors duration-200 text-white hover:text-gray-200 z-10"
                  aria-label="Close"
                  style={{ top: '-6px', right: '-6px' }}
                >
                  {/* Force use Heroicons XMarkIcon for a proper cross (X) icon */}
                  <XMarkIcon className="h-5 w-5" aria-label="Close" />
                </button>
              </div>

              <div className="flex mb-8 overflow-x-auto gap-4 justify-start">

                <button
                  className={`py-2 px-5 font-semibold text-base rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 ${activeSetupTab === 'category' ? 'bg-black text-white hover:bg-gray-900 active:bg-gray-800' : 'bg-transparent text-gray-500 hover:bg-gray-100 hover:text-gray-700'}`}
                  onClick={() => setActiveSetupTab('category')}
                >
                  Category
                </button>
              </div>
              <div className="flex-1 overflow-auto min-h-[300px]">
                {activeSetupTab === 'setup' && <AppointmentSetupPage accountFromUrl={accountFromUrl} acctId={acctId} />}
                {activeSetupTab === 'category' && <CategoryPage acctId={acctId} accountFromUrl={accountFromUrl} />}
              </div>
            </div>
          </div>
        </>
      )}

      {!isCalendarsLoading && dropdownOptions.length === 0 ? (
        <div className="flex items-center justify-center h-screen">
          {canCreateCalendar || (acctId && !hasAccountAccessError) ? (
            <div className="flex flex-col items-center">
              <PlusIcon
                className="text-gray-600 cursor-pointer hover:text-gray-800 w-16 h-16 transition-colors duration-200"
                onClick={handleAddCalendar}
                title="Add Calendar"
              />
              <p className="mt-2 text-gray-600 text-lg">Click to add your first calendar</p>
            </div>
          ) : (
            <p className="text-gray-600 text-lg">No calendars available</p>
          )}
        </div>
      ) : (
        <>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="relative w-12 h-12 mr-2 flex items-center justify-center">
                {/* Modern gradient background with shadow */}
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-400 via-teal-500 to-cyan-600 rounded-xl shadow-lg"></div>
                {/* Icon with better sizing and color */}
                <CalendarDaysIcon className="relative w-7 h-7 text-white drop-shadow-sm" />
                {/* Premium glow effect */}
                <div className="absolute -inset-0.5 bg-gradient-to-br from-emerald-400/40 via-teal-500/40 to-cyan-600/40 rounded-xl blur opacity-75 -z-10"></div>
              </div>
              <div>
                <h1 className="text-3xl font-bold text-black">
                  Appointments
                </h1>

              </div>
            </div>
            <div className="flex items-center space-x-2 -mr-1">
              {/* Settings Icon for Appointment Setup/Category */}
              <CogIcon
                className="w-5 h-5 text-gray-500 hover:text-black cursor-pointer ml-2"
                title="Category Settings"
                onClick={() => setActiveSetupTab('category') || setIsAppointmentSetupOpen(true)}
              />
              <CloudArrowUpIcon
                className="w-5 h-5 text-gray-500 hover:text-black cursor-pointer"
                title="Publish Appointment Flow"
                onClick={async () => {
                  setIsPanelLoading(true);
                  try {
                    const response = await fetch(`/api/appointment/gCal/waflow/publish/${accountFromUrl}/${acctId}`, {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      }
                    });

                    if (response.status === 200) {
                      showSuccess('Flow published to WhatsApp manager successfully!');
                    } else {
                      showError(`Publishing failed with status ${response.status}. Please try again later.`);
                    }
                  } catch (error) {
                    if (window.showError) window.showError('Something went wrong, please try after sometime.');
                  } finally {
                    setIsPanelLoading(false);
                  }
                }}
              />
              {canCreateCalendar && (
                <PlusIcon
                  className="rounded-md bg-black text-white p-[2px] hover:bg-gray-800 shadow
                    focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2
                    h-5 w-5 cursor-pointer stroke-[2]"
                  onClick={handleAddCalendar}
                  title="Add Calendar"
                />
              )}

              {selectedCalendar && dropdownOptions.length > 0 && (
                <TrashIcon
                  onClick={handleDeleteCalendarClick}
                  className={`w-5 h-5 ${dropdownOptions.length === 0
                    ? 'text-gray-400 cursor-not-allowed'
                    : 'text-red-600 hover:text-red-800 cursor-pointer'
                    }`}
                  title="Delete Selected Calendar"
                />
              )}
              {/* Calendar Combobox (Dashboard style, preserves dropdown logic) */}
              {/* Appointment Setup & Category Modal/Dialog */}
              {isAppointmentSetupOpen && (
                <>
                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30" aria-hidden="true" />
                  <div className="fixed inset-0 flex items-center justify-center p-4 z-50">
                    <div className="w-[80vw] max-w-[80vw] min-w-[700px] h-[80vh] max-h-[80vh] transform overflow-hidden rounded-lg bg-white p-10 text-left align-middle shadow-2xl transition-all relative flex flex-col" style={{ minHeight: '400px', maxWidth: '80vw', height: '80vh', maxHeight: '80vh', overflowY: 'auto' }}>
                      <div className="relative pt-0">
                        <button
                          type="button"
                          onClick={() => setIsAppointmentSetupOpen(false)}
                          className="absolute right-1 p-1 rounded-full bg-black hover:bg-gray-800 transition-colors duration-200 text-white hover:text-gray-200 z-10"
                          aria-label="Close"
                          style={{ top: '-14px', right: '-14px' }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                        </button>
                      </div>

                      <div className="flex border-b border-gray-200 mb-8 overflow-x-auto gap-4 justify-start">
                        <button
                          className={`py-2 px-4 font-medium text-sm ${activeSetupTab === 'category' ? 'border-b-2 border-black text-black' : 'text-gray-500 hover:text-gray-700'}`}
                          onClick={() => setActiveSetupTab('category')}
                        >
                          Category
                        </button>
                      </div>
                      <div className="flex-1 overflow-auto min-h-[300px]">
                        {activeSetupTab === 'setup' && <AppointmentSetupPage accountFromUrl={accountFromUrl} acctId={acctId} />}
                        {activeSetupTab === 'category' && <CategoryPage acctId={acctId} accountFromUrl={accountFromUrl} />}
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="w-56">
                <Combobox
                  options={dropdownOptions}
                  value={dropdownOptions.find(opt => opt.id === selectedCalendar) || null}
                  onChange={cal => {
                    if (cal && cal.id) {
                      handleDropdownChange({ target: { value: cal.id } });
                    }
                  }}
                  displayValue={cal => cal && cal.name ? cal.name : ''}
                  filter={(cal, query) => cal.name.toLowerCase().includes(query.toLowerCase())}
                  placeholder="Select a calendar"
                  className="w-full "
                  dropdownClassName=" min-w-[230px] max-w-[280px] bg-white"
                >
                  {(option) => (
                    <ComboboxOption key={option.id} value={option}>
                      <ComboboxLabel>{option.name}</ComboboxLabel>
                    </ComboboxOption>
                  )}
                </Combobox>
              </div>

            </div>
          </div>

          {selectedCalendar && dropdownOptions.length > 0 && (
            <>
              {isPanelLoading && (
                <LoadingMask loading={true} />
              )}
              <div className={`panel border border-gray-200 bg-white shadow-lg rounded-xl p-6  mt-5${isPanelLoading ? ' opacity-50' : ''} w-full mx-auto relative hover:shadow-xl transition-shadow duration-300`}>
                {/* Profile and Connect button section */}
                <div className="grid grid-cols-1 sm:grid-cols-2 items-center gap-x-12 ">
                  <div className="flex flex-col space-y-3">
                    {/* Profile section */}
                    <div className="flex items-center space-x-3">
                      {/* Only show profile image section when connected to Google */}
                      {isConnected ? (
                        <div className="relative group cursor-pointer" onClick={handleProfileImageClick}>
                          {/* Display new image preview or current profile image, fallback only if both missing */}
                          {(newProfileImagePreview || googlePicture) ? (
                            <div className="relative">
                              <img
                                src={
                                  newProfileImagePreview
                                    ? newProfileImagePreview
                                    : `${googlePicture}${googlePicture && googlePicture.includes('?') ? '&' : '?'}t=${Date.now()}`
                                }
                                alt=""
                                className="w-15 h-16 rounded-lg object-cover transition-opacity duration-200"
                                onError={e => {
                                  // If not already tried with crossOrigin, try again
                                  if (!e.target.crossOrigin) {
                                    e.target.crossOrigin = "anonymous";
                                    e.target.src = e.target.src;
                                  } else {
                                    // Fallback to initials SVG
                                    const initials = email ? email.charAt(0).toUpperCase() : 'U';
                                    const color = '#4285F4';
                                    const svg = `
                                      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'>
                                        <circle cx='50' cy='50' r='50' fill='${color}'/>
                                        <text x='50' y='50' font-family='Arial' font-size='40' 
                                          fill='white' text-anchor='middle' dominant-baseline='central'>
                                          ${initials}
                                        </text>
                                      </svg>
                                    `;
                                    e.target.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
                                  }
                                  setIsProfileImageLoading(false);
                                }}
                                onLoad={() => setIsProfileImageLoading(false)}
                              />
                              {isProfileImageLoading && (
                                <div className="absolute inset-0 flex items-center justify-center z-20 bg-black bg-opacity-30 backdrop-blur-xs rounded-lg">
                                  <svg className="animate-spin h-8 w-8 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                  </svg>
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className="w-15 h-16 rounded-lg bg-gray-200 flex items-center justify-center">
                              <FaUserCircle className="w-10 h-10 text-gray-400" />
                            </div>
                          )}

                          {/* Camera icon overlay on hover */}
                          <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                            <FaCamera className="text-white w-6 h-6" />
                          </div>

                          {/* Hidden file input */}
                          <input
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            onChange={handleProfileImageChange}
                            className="hidden"
                          />
                        </div>
                      ) : null}

                      <div className="flex flex-col ">
                        {/* Calendar name edit section */}
                        <div className="flex items-center ">
                          {isEditingName ? (
                            <div className="flex items-center gap-2">
                              <input
                                type="text"
                                className="border rounded px-2 py-1 text-base h-6 leading-tight"
                                defaultValue={dropdownOptions.find(opt => opt.id === selectedCalendar)?.name}
                                ref={input => { if (input) input.focus(); }}
                                onKeyDown={e => {
                                  if (e.key === 'Enter') {
                                    handleCalendarNameEdit(e.target.value);
                                  }
                                }}
                              />
                              <button
                                className="ml-1 text-green-600 hover:text-green-800"
                                title="Save Calendar Name"
                                onClick={e => {
                                  const input = e.target.closest('div').querySelector('input');
                                  if (input) handleCalendarNameEdit(input.value);
                                }}
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                              </button>
                              <button
                                className="ml-1 text-red-600 hover:text-red-800"
                                title="Cancel"
                                onClick={() => setIsEditingName(false)}
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                              </button>
                            </div>
                          ) : (
                            <div className="flex items-center">
                              <span className="text-base font-medium text-gray-900 mr-2"> {/* Increased text size */}
                                {dropdownOptions.find(opt => opt.id === selectedCalendar)?.name}
                              </span>
                              <FaPencilAlt
                                className="text-gray-400 hover:text-gray-600 cursor-pointer text-xs"
                                onClick={() => setIsEditingName(true)}
                                title="Edit Calendar Name"
                              />
                              <FaRegCopy
                                className="text-gray-400 hover:text-gray-600 cursor-pointer text-xs ml-2"
                                onClick={() => {
                                  navigator.clipboard.writeText(selectedCalendar);
                                  showSuccess('Calendar ID copied to clipboard');
                                }}
                                title="Copy Calendar ID"
                              />
                            </div>
                          )}
                        </div>
                        {email && <div className="text-base text-gray-600 -mt-0.5">{email}</div>} {/* Increased text size */}

                        {/* Only show timezone if it exists and isn't "Unknown" */}
                        {timeZone && timeZone !== "Unknown" ? (
                          <div className="text-sm text-gray-500 -mt-0.5">{timeZone}</div>
                        ) : (
                          <div className="text-sm text-gray-500 -mt-0.5">Asia/Calcutta</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-end">
                    {/* Only show Connect/Disconnect button when not loading and connection status is ready */}
                    {(!isPanelLoading && !isCalendarsLoading && isConnectionStatusReady) && (
                      <Button
                        className="cursor-pointer min-w-[150px]"
                        color={isConnected ? "red" : "green"}
                        onClick={isConnected ? handleDisconnectClick : handleConnectClick}
                        disabled={isPanelLoading}
                      >
                        {isPanelLoading ? "Loading..." : isConnected ? "Disconnect" : "Connect"}
                      </Button>
                    )}
                  </div>
                </div>

                {isConnected && (
                  <>
                    {/* Tab Navigation - Settings Style removed as requested. Divider above Pause Appointment removed. */}
                    {/* Tab Content */}
                    {activeTab === 'appointmentWindow' && (
                      <>
                        <div className="flex items-center justify-between gap-4 mt-3">
                          <div className="flex items-center">
                            <SwitchField className="flex items-center ">
                              <Label className="text-sm font-medium ">Pause Appointments</Label>
                              <Switch
                                name="pauseAppointment"
                                checked={pauseAppointment}
                                value={pauseAppointment}
                                onChange={handleToggleChange}
                                className={`cursor-pointer !transition-all !duration-300 ${pauseAppointment ? '!bg-red-500 [--switch-ring:white]' : '!bg-gray-200 [--switch-ring:red]'} !border-0 !outline-none !ring-0 !ring-offset-0 hover:!border-0 hover:!ring-0 hover:!outline-none focus:!ring-0 focus:!ring-offset-0 focus:!border-0`}
                              />
                            </SwitchField>
                          </div>
                          <div className="flex items-center">
                            <label htmlFor="calendar-id-field" className="text-xs font-semibold text-gray-700 mr-1">Calendar ID:</label>
                            <input
                              id="calendar-id-field"
                              type="text"
                              value={formData.calendarIdcopy}
                              onChange={e => {
                                setFormData(prev => ({
                                  ...prev,
                                  calendarIdcopy: e.target.value
                                }));
                                setIsFormChanged(true);
                                setIsSaveEnabled(true);
                                setIsEditingCalendarId(true);
                              }}
                              className="bg-white border border-gray-300 rounded px-2 py-1 text-xs text-gray-700 w-32"
                              style={{ marginRight: '2px' }}
                              onKeyDown={async e => {
                                if (e.key === 'Enter' && isFormChanged && isEditingCalendarId) {
                                  setIsPanelLoading(true);
                                  await handleUpdateCalendarId();
                                }
                              }}
                            />
                            {isFormChanged && isEditingCalendarId && (
                              <>
                                <button
                                  className="ml-2 text-green-600 hover:text-green-800"
                                  title="Save Calendar ID"
                                  onClick={async () => {
                                    setIsPanelLoading(true);
                                    await handleUpdateCalendarId();
                                    // Function to update calendar ID

                                  }}
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                                </button>
                                <button
                                  className="ml-1 text-red-600 hover:text-red-800"
                                  title="Cancel"
                                  onClick={() => {
                                    setFormData(prev => ({
                                      ...prev,
                                      calendarIdcopy: initialFormState?.calendarIdcopy || prev.calendarIdcopy
                                    }));
                                    setIsEditingCalendarId(false);
                                    setIsFormChanged(false);
                                    setIsSaveEnabled(false);
                                  }}
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                        <div className="border-t pt-4 mt-4">
                          <h4 className="text-center font-semibold mb-4">Appointment Window</h4>
                          <BookingAppoinment
                            disabled={pauseAppointment}
                            formData={formData}
                            onFormDataChange={handleFormDataChange}
                            onFieldChange={handleFieldChange}
                          />
                          <div className="flex justify-center mt-6">
                            <Button
                              onClick={handleSaveClick}
                              disabled={!isSaveEnabled || isSaving}
                              className="cursor-pointer"
                            >
                              {isSaving ? "Saving..." : "Save"}
                            </Button>
                          </div>
                        </div>
                      </>
                    )}
                    {activeTab === 'setupPage' && (
                      <div className="border-t pt-4 mt-4">
                        <AppointmentSetupPage accountFromUrl={accountFromUrl} acctId={acctId} />
                      </div>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}

      <DeleteConfirmation
        isOpen={isDeleteConfirmationOpen}
        onClose={closeDeleteConfirmationDialog}
        onConfirm={confirmDeleteCalendar}
        title={`Delete Calendar - ${dropdownOptions.find(cal => cal.id === selectedCalendar)?.name}`}
        message={`Are you sure you want to delete calendar "${dropdownOptions.find(cal => cal.id === selectedCalendar)?.name}"? This action cannot be undone.`}
      />

      <DeleteConfirmation
        isOpen={isConfirmationOpen}
        onClose={closeConfirmationDialog}
        onConfirm={confirmDisconnect}
        title="Confirm Disconnect"
        message="Are you sure you want to disconnect from Google Calendar? Your calendar settings will be lost."
      />      <AddCalendarDialog
        isOpen={isAddCalendarModalOpen}
        onClose={() => setIsAddCalendarModalOpen(false)}
        onSubmit={handleCreateCalendar}
        categories={categories}
        userRole={userRole}
      />
    </>
  );

}
export default GoogleCalendarPanel;